export const AUTHENTICATED = 'AUTHENTICATED';
export const LOGOUT = 'LOGOUT';
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_USER = 'AUTH_USER';
export const AUTH_TOKEN = 'AUTH_TOKEN';

export const SIGNUP_START = 'SIGNUP_START';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAIL = 'SIGNUP_FAIL';
export const SIGNUP_VIOLATIONS = 'SIGNUP_VIOLATIONS';

export const REQUEST_START = 'REQUEST_START';
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS';
export const REQUEST_FAIL = 'REQUEST_FAIL';

export const LOADER = "LOADER";

export const MODULE_CHANGE ="MODULE_CHANGE";
export const MESSAGES = "MESSAGES";
export const CLEAR_MESSAGES = "CLEAR_MESSAGES";

export const WINDOWS_MENUS_UPDATE ="WINDOWS_MENUS_UPDATE";

export const REDIRECT_URL = "REDIRECT_URL";
export const CLEAR_REDIRECT_URL = "CLEAR_REDIRECT_URL";

export const SET_SELECTED_TAGS = "SET_SELECTED_TAGS";

export const BOUNDARY_WARNING = 'BOUNDARY_WARNING';
